

import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { Config } from "./app/config";
import { AppComponent } from "./app/app.component";
import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";

if (environment.production) {
  enableProdMode();
}

// Function to load config and bootstrap the app
function loadConfigAndBootstrap() {
  // Check if jQuery is available
  if (typeof $ !== 'undefined' && $.getJSON) {
    $.getJSON("assets/config/config.json", (data) => {
      Config.assetConfigData = data;
      console.log(Config.assetConfigData);

      bootstrapApplication(AppComponent, appConfig).catch((err) =>
        console.error(err)
      );
    });
  } else {
    // Fallback: load config using fetch if jQuery is not available
    fetch("assets/config/config.json")
      .then(response => response.json())
      .then(data => {
        Config.assetConfigData = data;
        console.log(Config.assetConfigData);

        bootstrapApplication(AppComponent, appConfig).catch((err) =>
          console.error(err)
        );
      })
      .catch(err => {
        console.error("Failed to load config:", err);
        // Bootstrap without config
        bootstrapApplication(AppComponent, appConfig).catch((err) =>
          console.error(err)
        );
      });
  }
}

// Wait for DOM to be ready and jQuery to be available
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadConfigAndBootstrap);
} else {
  // DOM is already ready, but wait a bit for jQuery to load
  setTimeout(loadConfigAndBootstrap, 100);
}
